const ISO_DATE_REGEX =
  // oxlint-disable-next-line prefer-named-capture-group
  /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z|[+-](?:[01]\d|2[0-3]):[0-5]\d)?$/u

export const isDateString = (value: unknown): value is string =>
  typeof value === "string" && ISO_DATE_REGEX.test(value)
